import type { EvmChainId } from 'sushi/evm'
import type { WalletNamespaceFor } from '../types'

export function getNamespaceForChainId<TChainId extends EvmChainId>(
  _chainId: TChainId,
): WalletNamespaceFor<TChainId> {
  return 'evm' as WalletNamespaceFor<TChainId>
}
